import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useUserCredits } from "../hooks/useAuth";
import { useWalletLedger } from "../hooks/useEntitlements";

const CREDIT_MIGRATION_ACK_KEY = "credit_migration_ack_v1";
const LEGACY_REASON = "legacy_credit_migration";

export default function CreditMigrationModal() {
  const { t } = useTranslation();
  const { data: profile } = useUserCredits();
  const { data: ledger } = useWalletLedger();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (localStorage.getItem(CREDIT_MIGRATION_ACK_KEY)) return;

    const fromLedger = ledger?.some((line) => line.reason === LEGACY_REASON);
    const fromProfile = profile?.credit_migration_notice === true;

    if (fromLedger || fromProfile) {
      setOpen(true);
    }
  }, [ledger, profile]);

  const handleAck = () => {
    localStorage.setItem(CREDIT_MIGRATION_ACK_KEY, "1");
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleAck} maxWidth="sm" fullWidth>
      <DialogTitle>{t("creditMigration.title")}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ pt: 0.5 }}>
          {t("creditMigration.body")}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="contained" onClick={handleAck}>
          {t("common.continue")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
